
import {Prop, Ref, Vue} from "vue-property-decorator";
import Component from "vue-class-component";
import EqifyRuleBuilder from "@/components/rules/EqifyRuleBuilder.vue";
import {BModal} from "bootstrap-vue";
import EqifyRuleGroupViewer from "@/components/rules/viewer/EqifyRuleGroupViewer.vue";

@Component({
  components: {EqifyRuleGroupViewer, EqifyRuleBuilder}
})
export default class EqifyRuleViewer extends Vue {
  @Prop() rules?: Object

  @Ref("modal")
  private modal?: BModal = undefined

  openRulesModal() {
    this.modal!!.show()
  }
}
